<template>
    <div class='docs-list specs' id="specs" style="display: none;">
        <div style="min-height:600px;">
            <h1>Specification</h1>
            <section class="yunzi first" style="display: block;">
                <h3>Yunzi</h3>
                <p>
                    View & Download PDF&nbsp;
                    <a href="/static/docs/developerDocs/yunzi-specs-en.pdf" target="_blank">
                        Specification of Yunzi
                    </a>
                </p>
                <h3>4AA</h3>
                <p>
                    View & Download PDF&nbsp;
                    <a href="/static/docs/developerDocs/SmartBeacon_4AA.pdf" target="_blank">
                        Specification of 4AA
                    </a>
                </p>
                <h3>USB</h3>
                <p>
                    View & Download PDF&nbsp;
                    <a href="/static/docs/developerDocs/SmartBeacon_USB.pdf" target="_blank">
                        Specification of USB
                    </a>
                </p>
                <h3>4AA Pro</h3>
                <p>
                    View & Download PDF
                    <a href="/static/docs/developerDocs/SmartBeacon_4AA_Pro.pdf" target="_blank">
                        Specification of 4AA Pro
                    </a>
                </p>
                <h3>Alpha Base Station</h3>
                <p>
                    View & Download PDF&nbsp;
                    <a href="/static/docs/developerDocs/sensoro_base_station_en.pdf" target="_blank">
                        Specification of Alpha Base Station
                    </a>
                </p>
                <h3>Alpha Node-4AA</h3>
                <p>
                    View & Download PDF&nbsp;
                    <a href="/static/docs/developerDocs/node4aa_en.pdf" target="_blank">
                        Specification of Alpha Node-4AA
                    </a>
                </p>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        name: "specification"
    }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/docs/specification.vue